import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CountBox from '../../../components/CountBox';
import { useGlobalState } from '../../../store';

const ScoreView: React.FC = () => {
  const { t } = useTranslation();
  const [dApp] = useGlobalState('dApp');
  const [wait] = useState<number>(0);
  const [scoreLoading] = useGlobalState('scoreLoading');

  return (
    <CountBox
      title={t('oscore')}
      count={dApp && dApp.score ? dApp.score : '-'}
      tip={`${t('uncertified')} ${wait.toLocaleString()}`}
      icon="iconjifen"
      loading={scoreLoading}
    />
  );
};

export default ScoreView;
